import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Paper,
  TableRow,
} from "@mui/material";
import React from "react";
import { TableVirtuoso } from "react-virtuoso";
import Spinner from "../../components/spinner";
import MUITable from "./MUITable";

const VirtualizeTable = ({
  data,
  loading,
  columnLength,
  rowContent,
  isTableBlur,
  fixedHeaderContent,
  tableMessage = "No data available",
}) => {
  const renderEmptyPlaceholder = () => {
    return (
      <tbody>
        <tr>
          <td
            colSpan={columnLength}
            style={{ textAlign: "center", height: "100px" }}
          >
            {loading ? <Spinner /> : tableMessage}
          </td>
        </tr>
      </tbody>
    );
  };

  const VirtuosoTableComponents = {
    Scroller: React.forwardRef((props, ref) => (
      <TableContainer component={Paper} {...props} ref={ref} />
    )),
    Table: (props) => (
      <Table
        {...props}
        sx={{
          borderCollapse: "separate",
          tableLayout: "fixed",
          cursor: "default",
        }}
      />
    ),
    TableHead: React.forwardRef((props, ref) => (
      <TableHead {...props} ref={ref} />
    )),
    TableRow,
    TableBody: React.forwardRef((props, ref) => (
      <TableBody {...props} ref={ref} />
    )),
    EmptyPlaceholder: renderEmptyPlaceholder,
  };

  const dynamicHeight = Math.min(
    Math.max((data?.length + 1 || 1) * 50, 300),
    800
  );

  return (
    <>
      {data?.length < 30 ? (
        <MUITable
          {...{
            loading,
            data,
            columnLength,
            rowContent,
            isTableBlur,
            fixedHeaderContent,
            tableMessage,
          }}
        />
      ) : loading ? (
        <TableVirtuoso
          id="mui-vir-table"
          data={[]}
          style={{ height: `${dynamicHeight}px` }}
          components={VirtuosoTableComponents}
          fixedHeaderContent={fixedHeaderContent}
          itemContent={rowContent}
        />
      ) : (
        <TableVirtuoso
          data={data}
          id="mui-vir-table"
          style={{ height: `${dynamicHeight}px` }}
          components={VirtuosoTableComponents}
          fixedHeaderContent={fixedHeaderContent}
          itemContent={rowContent}
        />
      )}
    </>
  );
};

export default VirtualizeTable;
